// extracted by mini-css-extract-plugin
module.exports = {"card":"_1Vdmx5","cards":"_27CwTs","shine-lines":"_1QzBUg"};